import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@material-ui/core"
import { DeleteForever } from "@material-ui/icons"

// Diálogo genérico de confirmação de exclusão reutilizado em categoria/produto/passo/opção.
export default function DialogConfirmacao({
    open,
    titulo = "Confirmar exclusão",
    mensagem,
    nomeItem,
    textoConfirmar = "Excluir",
    onCancelar,
    onConfirmar,
}) {
    if (!open) return null
    return (
        <Dialog open={open} onClose={onCancelar} maxWidth="xs" fullWidth>
            <DialogTitle style={{ textAlign: "center" }}>
                <DeleteForever style={{ fontSize: "3.5rem", color: "#DC4C64" }} />
                <Typography variant="h6">{titulo}</Typography>
            </DialogTitle>
            <DialogContent>
                <Typography align="center">
                    {mensagem || "Tem certeza de que deseja excluir este item?"}
                    {nomeItem && (
                        <>
                            {" "}
                            <strong>{nomeItem}</strong>
                        </>
                    )}
                </Typography>
                <Typography
                    align="center"
                    variant="body2"
                    style={{ color: "#6b7280", marginTop: 8 }}
                >
                    Esta ação não pode ser desfeita.
                </Typography>
            </DialogContent>
            <DialogActions style={{ padding: "12px 20px" }}>
                <Button onClick={onCancelar}>Cancelar</Button>
                <Button
                    variant="contained"
                    style={{ backgroundColor: "#DC4C64", color: "white" }}
                    onClick={onConfirmar}
                >
                    {textoConfirmar}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
